import { type AssignableExamCourse } from '../../types';

export function mapExamCenterCourseData(assignableExamCourseData: AssignableExamCourse) {
  const { id, code, examId, name, type, language } = assignableExamCourseData;

  if (!id) {
    throw new Error('Id is required');
  }

  if (!examId) {
    throw new Error('Exam course exam ID is required');
  }

  if (!code) {
    throw new Error('Exam course code is required');
  }

  if (!name) {
    throw new Error('Exam course name is required');
  }

  if (!type) {
    throw new Error('Exam course type is required');
  }

  if (!language) {
    throw new Error('Exam course language is required');
  }

  return {
    id,
    examId,
    code,
    name,
    type,
    language,
  };
}
